import { useEffect, useState } from "react";
import { getDepartments } from "../services/departmentService";

const useDepartmentData = () => {
  const [departments, setDepartments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchDepartments();
    // eslint-disable-next-line
  }, []);

  const fetchDepartments = async () => {
    setLoading(true);
    try {
      let data = await getDepartments();
      setDepartments(data);
    } catch (error) {
      setError(error);
    } finally {
      setLoading(false);
    }
  };

  return {
    departments,
    loading,
    error,
  };
};

export default useDepartmentData;